module.exports = {
  "menu.btn.profile": "Profil",
  "menu.btn.shop": "Shop",
  "menu.btn.social": "Social",
  "menu.btn.maps": "Karten",
  "menu.btn.mods": "Modifizierungen",
  "menu.btn.settings": "Einstellungen",
  "menu.btn.customize": "Anpassen",
  "menu.btn.invite": "Einladen",
  "menu.btn.invite.clicked": "Kopiert",
  "menu.btn.join": "Beitreten",
  "menu.btn.host": "Gastgeber Spiel",
  "menu.btn.browser": "Server Browser",
  "generic.wait": "Bitte warten...",
  "generic.loading": "LÄDT...",
  "generic.connecting": "VERBINDET...",
  "generic.none": "Nichts",
  "generic.select": "Auswählen",
  "generic.delete": "Löschen",
  "generic.save": "Speichern",
  "generic.load": "Laden",
  "generic.search": "Suchen",
  "generic.leave": "Verlassen",
  "generic.default": "Voreinstellung",
  "generic.submit": "Senden",
  "generic.create": "Erstellen",
  "generic.failed": "Fehlgeschlagen",
  "generic.success": "Erfolgt!",
  "generic.name": "Name",
  "generic.level": "Level",
  "generic.score": "Spielstand",
  "generic.off": "Aus",
  "generic.score": "Score",
  "generic.victory": "SIEG",
  "generic.defeat": "NIEDERLAGE",
  "generic.follow": "Folgen",
  "generic.unfollow": "Nicht mehr folgen",
  "generic.followers": "Followers",
  "generic.following": "folgt",
  "generic.games": "Spiele",
  "generic.wins": "Siege",
  "generic.clan": "Clan",
  "generic.kills": "Abschüsse",
  "generic.deaths": "Tode",
  "generic.kdr": "KDR",
  "generic.games.played": "gespielte Spiele",
  "generic.games.won": "gewonnene Spiele",
  "generic.timep": "Spielzeit",
  "generic.time": "Zeit",
  "generic.logout": "Abmelden",
  "generic.logout.sessions": "Abmelden aus allen Sitzungen",
  "generic.username": "Benutzername eingeben",
  "generic.password": "Passwort eingeben",
  "generic.register": "Registrieren",
  "generic.login": "Einloggen",
  "generic.accuracy": "Genauigkeit",
  "player.waiting": "Warten auf Spieler",
  "player.died": "Du bist gestorben",
  "player.killed": "getötet von",
  "player.killstreak": "{0} on a {1} Abschuss-Strähne",
  "player.inactive": "Wegen Inaktivität entfernt",
  "player.disconnect": "NICHT VERBUNDEN",
  "timer.end": "Nächste Runde in {0}",
  "leaderboard.empty": "Leerer Warteraum",
  "popup.checkpoint": "Kontrollpunkt!",
  "app.play": "KLICKEN UM ZU SPIELEN",
  "app.play.controller": "START DRÜCKEN",
  "purchase.error": "Fehler aufgetreten",
  "purchase.error.click": "Hier klicken</a> und nochmal versuchen!",
  "purchase.error.limit": "Du hast möglicherweise dein tägliches Transaktionslimit überschritten.",
  "settings.reset": "Einstellungen zurücksetzen",
  "settings.reset.confirm": "Bist Du sicher, dass du all Deine Einstellungen zurücksetzen willst? Dadurch wird auch die Seite neu geladen",
  "settings.controls.change": "Kontrollen ändern",
  "settings.controls.press": "Irgendeine Taste drücken",
  "settings.server.header": "Server",
  "settings.server.region": "Voreinstellung Region",
  "settings.quality.header": "Qualität",
  "settings.quality.res": "Auflösung",
  "settings.quality.part": "Partikel",
  "settings.quality.trails": "Geschossspuren",
  "settings.quality.mflash": "Mündungsfeuer",
  "settings.interface.header": "Schnittstelle",
  "settings.interface.ui": "Benutzeroberfläche anzeigen",
  "settings.interface.hp": "Dynamische HP Balken",
  "settings.interface.chat": "Chat Box anzeigen",
  "settings.interface.kills": "Abschuss-Liste anzeigen",
  "settings.interface.messages": "Spielernachrichten anzeigen",
  "settings.interface.unboxings": "Ausgepackte Kisten anzeigen",
  "settings.interface.ping": "Ping anzeigen",
  "settings.interface.fps": "FPS-Rate anzeigen",
  "settings.interface.deaths": "Tode anzeigen",
  "settings.crosshair.header": "Fadenkreuz",
  "settings.crosshair.type": "Typ",
  "settings.crosshair.type.2": "Benutzerdefiniert",
  "settings.crosshair.type.3": "Mehrschichtig",
  "settings.crosshair.type.4": "Bild",
  "settings.crosshair.style": "Stil",
  "settings.crosshair.style.0": "Kreuz",
  "settings.crosshair.style.1": "Hohler Kreis",
  "settings.crosshair.style.2": "Voller Kreis",
  "settings.crosshair.style.3": "Hohles Quadrat",
  "settings.crosshair.style.4": "Volles Quadrat",
  "settings.crosshair.image": "Bild",
  "settings.crosshair.image.paste": "Fadenkreuz-Bild",
  "settings.crosshair.always": "Immer anzeigen",
  "settings.crosshair.color": "Farbe",
  "settings.crosshair.shadow": "Schatten",
  "settings.crosshair.size": "Größe",
  "settings.crosshair.thickness": "Dicke",
  "settings.onKillS.style.0": "Voreinstellung",
  "settings.onKillS.style.1": "Auflösung reduzieren",
  "settings.onKillS.style.2": "FOV reduzieren",
  "settings.onKillS.style.3": "FOV erhöhen",
  "settings.gameplay.header": "Spielverlauf",
  "settings.gameplay.sensitivity": "Empfindlichkeit",
  "settings.gameplay.aimsens": "Zielempfindlichkeit",
  "settings.gameplay.fov": "Sichtfeld",
  "settings.gameplay.fps": "FOV für Waffen",
  "settings.gameplay.streamer": "Streamer Modus",
  "settings.gameplay.challenge": "Challenge Modus",
  "settings.gameplay.invert": "Y-Achse umkehren",
  "settings.gameplay.onkillS": "Beim Abschuss",
  "settings.audio.header": "Audio",
  "settings.audio.sound": "Ton",
  "settings.audio.voice": "Lautstärke Stimmen",
  "settings.editing.header": "Bearbeiten",
  "settings.editing.weapon": "Waffe anzeigen",
  "settings.editing.bobbing": "Waffe rotieren",
  "settings.editing.depth": "Todeskarte",
  "settings.editing.green": "Grüner Bildschirm",
  "settings.shaders.header": "Schatten",
  "settings.shaders.ambient": "Umgebungsschatten",
  "settings.mods.header": "Mods",
  "settings.mods.load": "Mods laden",
  "settings.mods.auto": "Mods automatisch laden",
  "settings.mods.borders": "Zielfernrohr-Begrenzung",
  "settings.mods.scope": "Zielfernrohr-Bild",
  "settings.mods.scope.paste": "Zielfernrohr-Bild URL",
  "settings.mods.dot": "Laserpunkt-Bild",
  "settings.mods.dot.paste": "Laserpunkt-Bild URL",
  "settings.mods.endmessage": "Match Endnachricht",
  "settings.mods.profile": "Profil-Bild",
  "settings.mods.profile.paste": "Profil-Bild URL",
  "windows.settings.header": "Spieleinstellungen",
  "windows.servers.header": "Server Browser",
  "windows.servers.none": "Keine Spiele zum Beitreten gefunden...",
  "windows.servers.host": "+ Gastgeber-Spiel",
  "windows.servers.hide": "Volle ausblenden",
  "windows.servers.online": "{0} gesamt online",
  "windows.loadout.header": "Auslastung ändern",
  "windows.loadout.class": "Klasse",
  "windows.loadout.primary": "Primär",
  "windows.loadout.secondary": "Sekundär",
  "windows.loadout.melee": "Nahkampf",
  "windows.loadout.hat": "Hut",
  "windows.loadout.body": "Körper",
  "windows.loadout.spray": "Sprühdose",
  "windows.mods.header": "Mods Manager",
  "windows.mods.guide": "Mod Guide",
  "windows.mods.list": "Liste Modifizierungen",
  "windows.mods.publish": "Mods Veröffentlichen",
  "windows.mods.viewer": "Ansicht",
  "windows.mods.drop": "Mods hier hinziehen oder klicken",
  "windows.mods.paste": "Mod-Url einfügen",
  "windows.mods.load": "Mods laden",
  "windows.account.header": "Konto",
  "windows.account.recover": "Kontaktiere <a>krunker@yendis.ch</a> zur Wiederherstellung eines Kontos",
  "windows.class.header": "Klasse auswählen",
  "windows.controls.header": "Kontrollen bearbeiten",
  "windows.controls.forward": "Vorwärts",
  "windows.controls.backward": "Rückwärts",
  "windows.controls.left": "Links",
  "windows.controls.right": "Rechts",
  "windows.controls.reload": "Neu laden",
  "windows.controls.aim": "Zielen",
  "windows.controls.inspect": "Untersuchen",
  "windows.controls.spray": "Sprühen",
  "windows.controls.jump": "Springen",
  "windows.controls.crouch": "Kriechen",
  "windows.controls.next": "Nächste Waffe",
  "windows.controls.previous": "Vorherige Waffe",
  "windows.controls.chat": "Chat",
  "windows.controls.voice": "Stimme",
  "windows.controls.list": "Spieler Liste",
  "windows.controls.interact": "Interagieren",
  "windows.controls.drop": "Fallenlassen",
  "windows.host.header": "Individuelles Gastgeber-Spiel",
  "windows.host.maps": "Karten auswählen",
  "windows.host.cmaps": "Community Karte",
  "windows.host.raw": "Karten-Rohdaten",
  "windows.host.modes": "Modi auswählen",
  "windows.host.classes": "Klassen auswählen",
  "windows.host.settings": "Server Einstellungen",
  "windows.host.preset": "Gastgeber Voreinstellungen",
  "windows.host.preset.load": "Voreinstellung laden...",
  "windows.host.preset.name": "Name Voreinstellung",
  "windows.host.start": "Spiel starten",
  "windows.spray.header": "Sprühdose auswählen",
  "windows.spray.default": "Voreingestellte Sprühdose",
  "windows.maps.header": "Benutzerdefinierte Karten",
  "windows.maps.none": "Keine Karten gefunden!",
  "windows.maps.name": "Kartenname",
  "windows.maps.editor": "Karteneditor",
  "windows.maps.publish": "Karte veröffentlichen",
  "windows.maps.community": "Karten Community",
  "windows.publish.map.header": "Karte veröffentlichen",
  "windows.publish.map.thumbnail": "Keine Vorschauansicht",
  "windows.publish.map.paste": "Kartendaten einfügen",
  "windows.publish.map.update": "Veröffentlichen/Aktualisieren",
  "windows.publish.map.login": "Anmelden</a> um Karten zu erstellen und hochzuladen!",
  "windows.theatre.header": "Theater Modus",
  "windows.theatre.record": "Aufzeichnung aktivieren",
  "windows.theatre.key": "Aufzeichnungstaste",
  "windows.clans.header": "Clans",
  "windows.clans.members": "Mitglieder ({0})",
  "windows.clans.requests": "Anfragen",
  "windows.clans.requests.none": "Keine Anfragen",
  "windows.clans.page": "[{0}] Clan Seite",
  "windows.clans.create": "Clan erstellen",
  "windows.clans.name": "Clan Name",
  "windows.clans.view": "Clans ansehen",
  "windows.clans.join": "Clan beitreten",
  "windows.clans.login": "Anmelden</a> um Clan zu erstellen oder beizutreten!",
  "windows.store.header": "Shop",
  "windows.store.spin": "{0} Drehung(en)",
  "windows.store.agree": "Mit dem Kauf erklärst Du Dich mit den {0}Geschäftsbedingungen einverstanden.",
  "windows.store.purchase": "KR kaufen",
  "windows.store.market": "Marktplatz",
  "windows.store.market2": "Krunker Markt",
  "windows.store.buy": "Gegenstände kaufen und verkaufen auf dem",
  "windows.store.wheels": "Preisräder",
  "windows.store.unlock": "Neue Waffenoberflächen und Gegenstände freischalten",
  "windows.store.amount": "{0} KR in Konto",
  "windows.store.login": "Anmelden</a> um Gegenstände aus dem Shop zu kaufen und freizuschalten!",
  "windows.store.purchasing": "Kauf wird durchgeführt...",
  "windows.store.unboxed": "{0}{1} ausgepackt",
  "windows.skin.header": "Oberfläche auswählen",
  "windows.hat.header": "Hut auswählen",
  "windows.back.header": "Rückseite auswählen",
  "windows.mods.community.header": "Community Mods",
  "windows.mods.community.fav": "Deine Favoriten",
  "windows.mods.community.new": "Neue Mods",
  "windows.mods.community.hot": "Heiß",
  "windows.mods.community.name": "Mod-Name",
  "windows.mods.community.none": "Keine Mods gefunden!",
  "windows.publish.mod.header": "Mods veröffentlichen",
  "windows.publish.mod.thumbnail": "Keine Vorschauansicht",
  "windows.publish.mod.name": "Mods-Name",
  "windows.publish.mod.paste": "Mods-Url",
  "windows.publish.mod.update": "Veröffentlichen/Aktualisieren",
  "windows.publish.mod.login": "<a>Anmelden</a> um Mods zu erstellen und hochzuladen!",
  "windows.secondary.header": "Sekundäre auswählen",
  "windows.secondary.unlocked": "Freigeschaltet bei Level {0}",
  "windows.secondary.req": "Erfordert Level {0}",
  "windows.advertise.header": "Inserieren",
  "windows.players.header": "Spieler Liste",
  "windows.players.none": "Keine Spieler im Moment...",
  "windows.join.header": "Beitreten",
  "windows.join.code": "Spiel URL/Code eingeben",
  "windows.client.header": "Client",
  "windows.client.windows": "Windows Installer",
  "windows.client.mac": "macOS Installer",
  "windows.client.linux": "Linux Installer",
  "thumbnail.upload.limit": "Fehlgeschlagen. 40kb Limit für Vorschauansicht",
  "thumbnail.upload.error": "Fehler Vorschauansicht",
  "mod.extracting": "entpackt {0}/{1}",
  "mod.disabled": "Mods deaktiviert",
  "mod.error": "Mod Fehler!",
  "mod.loading": "Mod Lädt...",
  "mod.invalid": "Ungültige Mod-Datei!",
  "matchmaker.full": "VOLL",
  "matchmaker.full2": "Das Spiel ist voll.",
  "matchmaker.none": "Spiel nicht gefunden.",
  adblocker: "Schalte Deinen AdBlocker aus um gratis Krunkies zu erhalten.",
  "streamers.views": "{0} Betrachter",
  "streamers.none": "Keine aktiven Streams!",
  "error.extentions": "Schalte Erweiterungen aus, falls Du welche hast.",
  "error.seek": "Klicke und versuche, eine neues Spiel zu finden.",
  "custom.map.missing": "Wähle mindestens eine Karte aus",
  "custom.mode.missing": "Wähle mindestens einen Modus aus",
  "custom.class.missing": "Wähle mindestens eine Klasse aus",
  "server.config.maxPlayers": "Spieler",
  "server.config.minPlayers": "Mindestanzahl Spieler",
  "server.config.lives": "Leben",
  "server.config.gameTime": "Minuten",
  "server.config.gravMlt": "Schwerkraft",
  "server.config.jumpMlt": "Sprungkraft",
  "server.config.deltaMlt": "Zeitskala",
  "server.config.strafeSpd": "Strafe-Geschwindigkeit",
  "server.config.healthMlt": "Leben-Multiplikator",
  "server.config.impulseMlt": "Waffen-Impuls",
  "server.config.nameTeam1": "Team 1 Name",
  "server.config.nameTeam2": "Team 2 Name",
  "server.config.selTeam": "Team auswählen",
  "server.config.allowSpect": "Zuschauen",
  "server.config.killRewards": "Abschussprämien",
  "server.config.canSlide": "Rutschen",
  "server.config.autoJump": "Automatisch Springen",
  "server.config.thirdPerson": "Dritte Person",
  "server.config.nameTags": "Nametags ausblenden",
  "server.config.private": "Privat",
  "social.login": "Anmelden/Registrieren",
  "social.login.failed": "Anmeldung fehlgeschlagen",
  "social.login.buy": "Zum Kaufen anmelden",
  "social.login.sell": "Zum Verkaufen anmelden",
  "social.login.proccessing": "Anmeldung läuft...",
  "social.since": "Seit",
  "social.user.maps": "Benutzerkarten",
  "social.user.mods": "Benutzermodifizierungen",
  "social.maps.none": "Keine Karten gefunden...",
  "social.market.head": "Gegenstand Kopf",
  "social.market.back": "Gegenstand Rücken",
  "social.market.none": "Keine Gegenstände gefunden",
  "social.market.grace": "bereit in {0}",
  "social.market.sort": "Filtern/Sortieren",
  "social.market.filter": "Suchen",
  "social.market.price.high": "Höchster Preis",
  "social.market.price.low": "Niedrigster Preis",
  "social.market.price.list": "Preis anzeigen in",
  "social.market.searching": "Suchen",
  "social.market.listed": "angezeigt vor {0}",
  "social.market.list": "Gegenstand anzeigen",
  "social.market.unlist": "Nicht mehr anzeigen",
  "social.market.unlisting": "Gegenstand wird nicht mehr angezeigt...",
  "social.market.posting": "Gegenstand wird gepostet...",
  "social.market.req": "Level {0} erforderlich",
  "social.market.cant": "Kannst Du Dir nicht leisten",
  "social.market.purchase": "Kaufen",
  "social.market.fee": "Keine Gebühr fürs Listen",
  "social.market.failed": "Fehlgeschlagen. Versuche es erneut."
};